import { api } from "../index";

export interface InboundItemDto {
  id: number;
  companyId: number;
  inboundId: number;
  poItemId: number;
  warehouseId: number;
  description?: string;
  partialDelivery: boolean;
  deliveryNo: number;
  quantityDelivered: number;
  weight: number;
  product?: {
    id: number;
    name: string;
    code: string;
  };
  unit?: {
    id: number;
    name: string;
    code: string;
  };
}

export interface CreateInboundItemDto {
  poItemId?: number;
  description?: string;
  deliveryNo: number;
  quantityDelivered: number;
  weight: number;
  productId?: number;
  unitId?: number;
  workOrder?: string;
}

export interface UpdateInboundItemDto {
  description?: string;
  partialDelivery: boolean;
  quantityDelivered: number;
}

const inboundItems_uri = "api/inbounditems";

export const getInboundItemById = async (id: number): Promise<InboundItemDto> => {
  const response = await api.get(`${inboundItems_uri}/${id}`);
  return response.data;
};

export const getInboundItems = async (): Promise<InboundItemDto[]> => {
  const response = await api.get(inboundItems_uri);
  return response.data;
};

export const getInboundItemsByInboundId = async (inboundId: number): Promise<InboundItemDto[]> => {
  const response = await api.get(`${inboundItems_uri}/inbound/${inboundId}`);
  return response.data;
};

export const createInboundItem = async (data: CreateInboundItemDto): Promise<InboundItemDto> => {
  const response = await api.post(inboundItems_uri, data);
  return response.data;
};

export const updateInboundItem = async (id: number, data: UpdateInboundItemDto): Promise<InboundItemDto> => {
  const response = await api.put(`${inboundItems_uri}/${id}`, data);
  return response.data;
};

export const deleteInboundItem = async (id: number): Promise<void> => {
  await api.delete(`${inboundItems_uri}/${id}`);
};
